import { Response, PaginatedResponse } from './Deploy.ts';

export interface DailyDeployNumberResult {
  date: string; // <datetime>
  contract_calls_num: number; // number of contract calls made on that day
  native_transfer_num: number; // number of native transfers made on that day
  total_contract_calls_num: number; // accumulated number of contract calls made from the start of the network until that day (including)
  total_native_transfers_num: number; // accumulated number of native transfers made from the start of the network until that day (including)
  acc_total_deploys_number: number;
  burned_fees: string;
  total_burned_fees: string;
}

export function DailyDeployNumber(obj: any): DailyDeployNumberResult {
  return obj;
}

export const MapDailyDeployNumberResult = ({
  data,
  ...props
}: Response<DailyDeployNumberResult>): Response<DailyDeployNumberResult> => ({
  ...props,
  data: data
    ? data.map((item) => {
        return {
          ...item,
          acc_total_deploys_number:
            item.contract_calls_num + item.native_transfer_num,
        };
      })
    : [],
});
